import { render, staticRenderFns } from "./PaymentData.vue?vue&type=template&id=dc1fe5b4&scoped=true"
import script from "./PaymentData.vue?vue&type=script&lang=js"
export * from "./PaymentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1fe5b4",
  null
  
)

export default component.exports